/** 
 * @type {ComponentTransactionsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    component_ids: null,
    currency_ids: null,
    modes: null,
}
/** 
* @returns {ComponentTransactionsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/ComponentTransactionsFilter.js